document.addEventListener('touchmove', function (e) {
	e.preventDefault();
});

$.ready(function () {
	/* globals loader */

	var resize = function () {
		var viewport = {
			width:  document.documentElement.clientWidth, // window.innerWidth
			height: document.documentElement.clientHeight, // window.innerHeight
		};
		
		loader.css(viewport);
		window.scrollTo(0, 0);
		
		game.emit('viewport', viewport);
		game.css(viewport);
		
		game.emit('scale', {
			viewport: viewport,
			resize: function (dimensions, element, _viewport) {
				_viewport = _viewport || this.viewport;

				var scaleW = _viewport.width / dimensions.width;
				var scaleH = _viewport.height / dimensions.height;
				var scale  = Math.min(scaleW, scaleH);
				
				var width  = scale * _viewport.width  / scaleW;
				var height = scale * _viewport.height / scaleH;
				
				var font = Math.floor(scale * dimensions.font);
				
				if (element) {
					element.css({
						width: width,
						height: height,
						'font-size': font,
					});
				}
				
				return {
					width: width,
					height: height,
					font: font,
				};
			},
		});
	};
	
	window.addEventListener('resize', resize);
	document.addEventListener('resize', resize);
	
	setTimeout(resize, 0);
});



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/common/scale/scale.js
 **/